import {GetNotificationsV2Response} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/notification_center/v1/service.types';
import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from 'react';
import {useGetNotificationsCallback} from './useGetNotifications';

const NotificationContext = createContext<{
  notificationsData: GetNotificationsV2Response | undefined;
  fetchNotifications: () => Promise<GetNotificationsV2Response | undefined>;
}>({
  notificationsData: undefined,
  fetchNotifications: () => Promise.resolve(undefined),
});

export const useNotifications = () => useContext(NotificationContext);

export const NotificationProvider = ({children}: PropsWithChildren) => {
  const {notificationsData, fetchNotifications} = useGetNotificationsCallback();

  const memoValue = useMemo(() => {
    return {notificationsData, fetchNotifications};
  }, [fetchNotifications, notificationsData]);

  return (
    <NotificationContext.Provider value={memoValue}>
      {children}
    </NotificationContext.Provider>
  );
};
